export const STATUS_LABELS = {
  planlama: "Planlama",
  yapim_asamasi: "Yapım Aşaması",
  tamamlandi: "Tamamlandı",
  kesin_kabul: "Kesin Kabul",
  beklemede: "Beklemede",
  islemde: "İşlemde",
  sonuclandi: "Sonuçlandı",
};

export const STATUS_COLORS = {
  planlama: "bg-amber-50 text-amber-700 border-amber-200",
  yapim_asamasi: "bg-blue-50 text-blue-700 border-blue-200",
  tamamlandi: "bg-emerald-50 text-emerald-700 border-emerald-200",
  kesin_kabul: "bg-purple-50 text-purple-700 border-purple-200",
  beklemede: "bg-orange-50 text-orange-700 border-orange-200",
  islemde: "bg-sky-50 text-sky-700 border-sky-200",
  sonuclandi: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const INFRA_TYPES = {
  icme_suyu: "İçme Suyu",
  kanalizasyon: "Kanalizasyon",
  sulama: "Sulama Suyu",
};

export const INVESTMENT_TYPES = {
  dogrudan: "Doğrudan",
  ihaleli: "İhaleli",
};

export const PETITION_TYPES = {
  dilekce: "Dilekçe",
  ariza: "Arıza",
  etud: "Etüt Projesi",
};

export const INFRA_STATUSES = ["planlama", "yapim_asamasi", "tamamlandi", "kesin_kabul"];
export const PETITION_STATUSES = ["beklemede", "islemde", "sonuclandi"];

export function formatMoney(n) {
  if (n === null || n === undefined || isNaN(n)) return "0,00 ₺";
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(n);
}

export function formatDate(iso) {
  if (!iso) return "-";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("tr-TR");
}

export const trDates = (s) => (s || "").replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, "$3.$2.$1");
export const formatDateTime = (iso) => new Date(iso).toLocaleString("tr-TR", { timeZone: "Europe/Istanbul" });
